import "./BathroomRemodelServiceAreasNearLakelandFL.module.css";
import Navigation from "@/reusable_sections/Header";
import BathroomHero from "./sections/BathroomHero";
import ServiceAreas from "./sections/ServiceAreas";
import Locations from "./sections/Locations";
import Footer from "@/reusable_sections/Footer";
import QuoteForm from "./sections/QuoteForm";
import LakelandServiceAreaFAQ from "./sections/LakelandServiceAreaFAQ";
export default function BathroomRemodelServiceAreasNearLakelandFLPage() {
  return <div>
      <Navigation />
      <BathroomHero />
      
      <ServiceAreas />
      <Locations />
      <LakelandServiceAreaFAQ />
      <Footer />
    </div>;
}